import Skeleton from "react-loading-skeleton";

const Button = ({
  icon,
  label,
  primary,
  noBorder,
  onClick,
  loading,
  height = 35,
  width = 150,
}) => {
  if (loading) return <Skeleton width={width} height={height} />;
  return (
    <button
      type="button"
      className={`btn-secondary px-3 py-2 
        ${primary ? "" : "custom-theme-color"}
        ${noBorder && "border-0"}
        `}
      onClick={onClick}
    >
      <div className="d-flex justify-content-center align-items-center ">
        {icon}
        <span className="px-1">{label}</span>
      </div>
    </button>
  );
};

export default Button;
